<script setup lang="ts">
import { toTypedSchema } from '@vee-validate/zod'
import { useField, useForm } from 'vee-validate'
import * as zod from 'zod'
import { useProfileSelfStore } from '~/stores/user/Self'

import type { Profile } from '~/types/profile'
import Modal from '~/components/Common/Modal/Modal.vue'
import TextArea from '~/components/Common/Form/TextArea.vue'
import Button from '~/components/Common/Button/Button.vue'

const props = defineProps<{
	show: boolean
	user: Profile
}>()

const emits = defineEmits(['close', 'success', 'errored'])

const store = useProfileSelfStore()

// Form validation schema
const validationSchema = toTypedSchema(
	zod.object({
		bio: zod.string().min(20, 'Please write a bio with at least 20 characters'),
	}),
)

const { handleSubmit, errors } = useForm({
	validationSchema,
})

const { value: bio } = useField('bio')

const onSubmit = handleSubmit(async () => {
	if (!props.user.id) {
		console.error('User is required')
		emits('errored', 'User is required')
		return
	}

	try {
		await store().setBio(bio.value as string)
		emits('success')
	} catch (err: any) {
		console.error(err)
		emits('errored', err.message || 'An unexpected error occurred')
	}
})
</script>

<template>

	<Modal
		:show="show"
		title="Introduce Yourself..."
		class="max-h-fit"
		boxClass="w-full sm:max-w-xl"
		@close="emits('close')">

		<form class="space-y-4" @submit.prevent="onSubmit">

			<TextArea
				v-model="bio"
				placeholder="Tell us about yourself"
				:rows="6"
				label="Write your bio"
				:error="errors.bio"
			/>

				<div class="flex">
					<Button type="submit">
						Submit
					</Button>
				</div>
			</form>

	</Modal>
</template>
